import { createApiCallActions } from '../../../common/store/generic.actions';
import {
  InsuranceClaimFormModel,
  InsuranceClaimModel,
  InsuranceClaimStatusFlow,
  InsuranceClaimStatusHistoryModel,
} from './types';
import { Action } from '../view/types';

export const insuranceClaimActions = {
  getById: createApiCallActions<InsuranceClaimModel>(
    'insuranceClaim',
    'getById',
  ),
  getByUniqueId: createApiCallActions<InsuranceClaimModel>(
    'insuranceClaim',
    'getByUniqueId',
  ),
  createInstance: createApiCallActions<InsuranceClaimFormModel>(
    'insuranceClaim',
    'createInstance',
  ),
  add: createApiCallActions<InsuranceClaimModel>('insuranceClaim', 'add'),
  update: createApiCallActions<InsuranceClaimModel>('insuranceClaim', 'update'),
  generateDocuments: createApiCallActions<boolean>(
    'insuranceClaim',
    'generateDocuments',
  ),
  requestValidation: createApiCallActions<boolean>(
    'insuranceClaim',
    'requestValidation',
  ),
  validate: createApiCallActions<boolean>('insuranceClaim', 'validate'),
  openDossierToTransmitter: createApiCallActions<boolean>(
    'insuranceClaim',
    'openDossierToTransmitter',
  ),
  openClaim: createApiCallActions<boolean>('insuranceClaim', 'openClaim'),
  close: createApiCallActions<boolean>('insuranceClaim', 'close'),
  reopen: createApiCallActions<boolean>('insuranceClaim', 'reopen'),
  reject: createApiCallActions<boolean>('insuranceClaim', 'reject'),
  getStatusHistory: createApiCallActions<InsuranceClaimStatusHistoryModel>(
    'insuranceClaim',
    'getStatusHistory',
  ),
  updateStatusHistory: createApiCallActions<InsuranceClaimStatusHistoryModel>(
    'insuranceClaim',
    'updateStatusHistory',
  ),
  deleteStatusHistory: createApiCallActions<boolean>(
    'insuranceClaim',
    'deleteStatusHistory',
  ),
  getStatusFlow: createApiCallActions<InsuranceClaimStatusFlow[]>(
    'insuranceClaim',
    'getStatusFlow',
  ),
  getStatusActions: createApiCallActions<Action[]>(
    'insuranceClaim',
    'getStatusActions',
  ),
};

export type InsuranceClaimAction = typeof insuranceClaimActions;
